interface Record {
	TagId: number;
	Value: any;
	DateInMilliseconds: number;
    JavascriptDate: Date;
    Quality: number;
    LastChangeValue: string;
    LastChangeDateInMilliseconds: number;
    DateOfLastChangedValueInMS: number;
    LocalUpdateDateUTCMS: number;
    RecentlyUpdated: boolean;
	RecentlyUpdatedDate: number;
	RedisKeyName?: string;
	    
    DurationInMS(): number;
    ObservationLocalDate(): Date;
    ObservationUTCDate(): Date;
    ObservationUTCDateMS(): number;
    UTCJavascriptDate(): Date;
    PLCLocalDate(): Date;
    PLCUTCDate(): Date;
    UserDateFull(): Date;
    UTCDateFull(): Date;
}

export class IObservation implements Record {
	TagId: number;
	Value: any;
	DateInMilliseconds: number;
    JavascriptDate: Date;
    Quality: number;
    LastChangeValue: string;
    LastChangeDateInMilliseconds: number;
    DateOfLastChangedValueInMS: number;
    LocalUpdateDateUTCMS: number;
    RecentlyUpdated: boolean;
	RecentlyUpdatedDate: number;
	RedisKeyName?: string;
	
	constructor(
		TagId: number,
		Value: any,
		DateInMilliseconds: number,
        JavascriptDate: Date,
        Quality: number,
        LastChangeValue: string,
        LastChangeDateInMilliseconds: number,
        DateOfLastChangedValueInMS: number,
        LocalUpdateDateUTCMS: number,
        RecentlyUpdated: boolean,
        RecentlyUpdatedDate: number,
        RedisKeyName?: string
	
	) {
		this.TagId = TagId;
		this.Value = Value;
		this.DateInMilliseconds = DateInMilliseconds;
        this.JavascriptDate = JavascriptDate;
        this.Quality = Quality;
        this.LastChangeValue = LastChangeValue;
        this.LastChangeDateInMilliseconds = LastChangeDateInMilliseconds;
        this.DateOfLastChangedValueInMS = DateOfLastChangedValueInMS;
        this.LocalUpdateDateUTCMS = LocalUpdateDateUTCMS;
        this.RecentlyUpdated = RecentlyUpdated;
	    this.RecentlyUpdatedDate = RecentlyUpdatedDate;
	    this.RedisKeyName = RedisKeyName;

	}

    public DurationInMS(): number {
		const currentTime = Date.now();
		const currentValue = this.Value ? this.Value : null;
		const lastChangeValue = this.LastChangeValue ? this.LastChangeValue : null;
		
		// Compare current value with the last change value
		if (currentValue !== lastChangeValue) {
		  // If the current value is different, use the changed date
		  return Math.abs(currentTime - this.DateInMilliseconds);
		} 
		else {
		  // If the current value is the same, use the last changed date (if exists)
		  if (this.LastChangeDateInMilliseconds) {
			return Math.abs(currentTime - this.LastChangeDateInMilliseconds);
		  }
		  return Math.abs(currentTime - this.DateInMilliseconds);
		}
	}

    public ObservationLocalDate(): Date {
        return new Date(this.DateInMilliseconds);
    }

    public ObservationUTCDate(): Date {
        return this.convertMillisecondsToDateWithTimezoneOffset(this.DateInMilliseconds, 0); // Get UTC TimeZone offset then call utility service to convert the utc milliseconds to site date
    }

    public ObservationUTCDateMS(): number {
        return this.DateInMilliseconds;
    }

    public UTCJavascriptDate(): Date {
        return this.convertMillisecondsToDateWithTimezoneOffset(this.DateInMilliseconds, 0);
    }

    public PLCLocalDate(): Date {
        return new Date(this.DateInMilliseconds);
    }

    public PLCUTCDate(): Date {
        return this.convertMillisecondsToDateWithTimezoneOffset(this.DateInMilliseconds, 0);
    }

    public UserDateFull(): Date {
        return new Date(this.DateInMilliseconds);
    }

    public UTCDateFull(): Date {
        return this.convertMillisecondsToDateWithTimezoneOffset(this.DateInMilliseconds, 0);
    }


    private convertMillisecondsToDateWithTimezoneOffset(milliseconds: number, timezoneOffset: number) : any {
		if (!isNaN(milliseconds) && !isNaN(timezoneOffset)) {
			if (timezoneOffset !== 0 && !timezoneOffset) return null;

			let offsetTargetInMin = timezoneOffset * 60;
			var date = new Date(milliseconds); //    date.setHours(offset);
			var offset = new Date().getTimezoneOffset();

			let offsetToApplyToThisTimezone: any;
			let calculatedOffsetSoFar = offsetTargetInMin + offset;
			offsetToApplyToThisTimezone = calculatedOffsetSoFar / 60;

			let finalDateInMs = date.setHours(
				date.getHours() + offsetToApplyToThisTimezone
			);
			return new Date(finalDateInMs);
		}
		else {
			return null;
		}
	}
}